import React from 'react'
import { CFooter } from '@coreui/react'

const BackAppFooter = () => {
    return (
        <CFooter className="px-4">
            <div>
                <a href="https://thesustain.net/" target="_blank" rel="noopener noreferrer">
                    THE  SUSTAINT DASHBOARD
                </a>
                <span className="ms-1">&copy; 2025 The Sustain.</span>
            </div>
            <div className="ms-auto">
                <span className="me-1">Powered by</span>
                <a href="https://yemmbackpierre.site/" target="_blank" rel="noopener noreferrer">
                    PYM FULL-STACK DEV Admin &amp;
                </a>
            </div>
        </CFooter>
    )
}

export default React.memo(BackAppFooter)
